import { useMatchRoute } from "@tanstack/react-router";
import { pick } from "remeda";
import { useStoredLocationId } from "services/locationOrgContext";
import type { NavItemLink } from "./types";

export function useDoesPathMatch({
  external,
  matchSubpaths,
  path,
}: Pick<NavItemLink, "external" | "matchSubpaths" | "path">) {
  const matchRoute = useMatchRoute();

  if (external) return false;
  return matchSubpaths
    ? !!matchRoute({ to: path }) || matchSubpaths.some((subpath) => !!matchRoute({ to: subpath }))
    : !!matchRoute({ to: path, fuzzy: true });
}

type ParamsIn = { locationId?: string };

export function useInheritLocation() {
  const storedLocationId = useStoredLocationId();
  return (prev: ParamsIn) => ({ ...prev, locationId: prev.locationId ?? String(storedLocationId ?? -1) });
}

export function useNavLinkProps() {
  const params = useInheritLocation();
  return (item: Pick<NavItemLink, "path" | "keepParams" | "search" | "external">) => {
    if (item.external) return { to: item.path };
    const { keepParams, search } = item;
    return {
      to: item.path,
      params,
      search: (prev: Record<string, unknown>) => ({ ...(keepParams ? pick(prev, keepParams) : {}), ...search }),
    };
  };
}
